import React, { useEffect } from "react";
import Contact from "./Contact";
import "./Contacts.css";
import { Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { removeSpinnetBotScript } from "../../../utils/ChatbotScriptHelpers";

const Contacts = ({
  userId,
  onContactClicked,
  contacts = [],
  selectedId,
  allProfileImages,
  startConversation,
  forCall,
  startChatWithContact,
  setSelectedContact,
  favourites,
  removeConversationFromFavourites,
  addConversationToFavourites,
  openRecharge,
  balance
}) => {
  useEffect(() => {
    removeSpinnetBotScript();
  }, []);
  const dispatch = useDispatch()
  return (
    <div className="">
      {contacts.length > 0 ? (
        <ul className="app-item-list list mb-0">
          {contacts
            .sort((a, b) => {
              let fa = a.userName.toLowerCase(),
                fb = b.userName.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .map((contact, index) => (
              <Contact
                key={index}
                openRecharge={openRecharge}
                balance={balance}
                startChatWithContact={startChatWithContact}
                userId={userId}
                allProfileImages={allProfileImages}
                startConversation={startConversation}
                contact={contact}
                setSelectedContact={setSelectedContact}
                onContactClicked={(e,imgSrc) => {
                  dispatch(onContactClicked({contact, imgSrc}))
                  e.preventDefault();
                }}
                highlight={selectedId && contact.userId === selectedId}
                forCall={forCall}
                favourites ={favourites}
                removeConversationFromFavourites={removeConversationFromFavourites}
                addConversationToFavourites={addConversationToFavourites}
              />
            ))}
        </ul>
      ) : (
        <div className="px-2 py-4 text-center">
          <Typography variant="body1" sx={{ color: "#4a4a4a" }} className="!text-size-14">
            No matching search results.
          </Typography>
        </div>
      )}
    </div>
  );
};

export default Contacts;
